import React, { useState, useEffect, useCallback } from 'react'
import { useDispatch, useSelector } from "react-redux";
import Modal from 'react-bootstrap/Modal';
import {getMultipleDocs, getDocumentdetails } from "../../actions/assetDocumentsActions";
import { AgGridReact } from 'ag-grid-react';
import moment from "moment";
import notificationSVG from '../../asset/Images/notification-text.svg';
import { param } from 'jquery';
import { getAssetNoteDetails } from '../../actions/assetNotestabAction';
import {DownloadDocument, getDocbyActivityId, getDocdetailsbyDocumentId} from '../../../config/apiConfig';
import { sbaAxios } from '../../utils/sbaAxios';
import noDataAvailable from '../../../Images/noDataAvailable.svg';
import { toast } from 'react-toastify';


export const AssetDocumentsList = () => {
  const [showDocuments, setShowDocuments] = useState(false);
  const [multiDocuView,setMultiDocuView]=useState(false);
  const [documents, setDocuments] = useState([]);
  const [showMultiDocModal, setShowMultiDocModal] = useState(false);
  const dispatch = useDispatch();
  const Gstate = useSelector(state => { return state; }) || {};
  const Docs = Gstate.Documents.Documents || [];
  const AssetDocs=Gstate?.assetDocuments?.assetDocuments ||[];
  const [assetDocuments, setAssetDocuments] = useState([]);
  const iconOnClick=useCallback((params)=>
  {
     
    dispatch(getAssetNoteDetails(params.data.ActivityId));
    if(params.data.DocumentId===-1)
    {
      setMultiDocuView(true);
      dispatch(getMultipleDocs(params.data.ActivityId));
    }
    else{
      setMultiDocuView(false);
      dispatch(getDocumentdetails(params.data.DocumentId));
    }
  },[]);

  const fetchDocumentExtension = async(DocumentId) => {
    try{
      const doc = await sbaAxios({
        url: `${getDocdetailsbyDocumentId}${DocumentId}`,
        method: 'get',
      })
      return doc?.DocumentExtension;
    }
    catch(e){
      return null
    }
  };

  useEffect(()=> {
    const updateDocs = async () => {
      if (AssetDocs?.length > 0) {
        const updatedAssetDocs = await Promise.all(
          AssetDocs.map(async (item) => {
            if (item.DocumentId !== -1) {
              const ext = await fetchDocumentExtension(item.DocumentId);
              return { ...item, DocExt: ext };
            } else {
              return { ...item, DocExt: null };
            }
          })
        );
        setAssetDocuments(updatedAssetDocs);
      }
    };
  
    updateDocs();
  },[AssetDocs])

  const handleClose=()=>setShowDocuments(false);
  const fetchMultiDocuments = async (activityId) =>{
    try{
      const list = await sbaAxios({
        url: `${getDocbyActivityId}${activityId}`,
        method: 'get',
      });
      setDocuments(list);
    }
    catch(e){

    }
  }
  const pdfview = (documentId) => {
    const encodedDocumentId = btoa(documentId.toString());      
    const urls = DownloadDocument + encodedDocumentId;       
    try{
        sbaAxios({
            url: urls,

        }).then((response) => {
            window.open(urls);
      })
    }
    catch (error){
      console.error('Error opening PDF:', error);
    }
  }
  const DocumentTabPopUp=()=>{

    const multiDocu=useSelector(state=>state.mutipleDocuments.mutipleDocuments) || [];
    const singleDocu=useSelector(state=>state.documentDetails.documentDetails) || [];
    const assetDocu=useSelector(state=>state.assetDocuments.assetDocuments) || [];
      
    const noteDetails = useSelector(state => state.notesTabDetails.noteDetails);
    const noteDate=moment(noteDetails?.ActivityDate).format('MM-DD-YYYY');
    if(multiDocuView===true)
    return (
      <>{ multiDocu?.length===0 ? <label>No Documents Available </label> :
      multiDocu.map(item=>{
        return (
          <div class="card-body p-0">
            <div class="row p-3 border-bottom  m-0">
              <div class="col-11 left">
              <span className='SBA_hand'>
                <i 
                class={`far fa-file-${(item.DocumentExtension === "pdf" || item.DocumentExtension === ".pdf") ? 'pdf':'excel'}`} 
                style={{ color: `${(item.DocumentExtension === "pdf" || item.DocumentExtension === ".pdf") ? 'red':'green'}` }} 
                onClick={() => pdfview(item.DocumentId)}></i> 
              </span>
                <span style={{marginLeft: 10}}>{item.DocumentName}</span>
              </div>
            </div>
          </div>

        );
      })
      }
       <div className='row my-2'>
            <div className='col-md-4'> <div className='fw-medium'>Owner :</div><div className='fw-medium'>{noteDetails?.ActivitySource}</div></div>
            <div className='col-md-4'><div className='fw-medium'>Created BY :</div><div className='fw-medium'>{noteDetails?.ActivitySource}</div></div>
            <div className='col-md-4'><div className='fw-medium'>Date Created :</div><div className='fw-medium'>{noteDate}</div></div>
        </div>
        <div className='fw-medium '>Subject :</div>
        <div className='fw-medium mb-2'>{noteDetails.ActivityName}</div>
        <div className='fw-medium '>Body :</div>
        <div className='detail p-2' id='notesTabContent' style={{ overflowY: 'scroll', height: "50vh" }} dangerouslySetInnerHTML={{ __html: noteDetails.ActivityDescriptionHTML }}></div>
      </>
    )
    else
    return (
      <>{singleDocu && 
        <div class="card-body p-0">
        <div class="row p-3 border-bottom  m-0">
          <div class="col-11 left">
            <span className='SBA_hand'>
            <i 
                class={`far fa-file-${(singleDocu.DocumentExtension === "pdf" || singleDocu.DocumentExtension === ".pdf") ? 'pdf':'excel'}`} 
                style={{ color: `${(singleDocu.DocumentExtension === "pdf" || singleDocu.DocumentExtension === ".pdf") ? 'red':'green'}` }} 
                onClick={() => pdfview(singleDocu.DocumentId)}></i>
            </span>
            <span style={{marginLeft: 10}}>{singleDocu.DocumentName}</span>
          </div>

        </div>
      </div>
      }
       <div className='row my-2 mt-4'>
            <div className='col-md-4'> <div className='fw-medium'>Owner :</div><div className='fw-medium'>{noteDetails?.ActivitySource}</div></div>
            <div className='col-md-4'><div className='fw-medium'>Created BY :</div><div className='fw-medium'>{noteDetails?.ActivitySource}</div></div>
            <div className='col-md-4'><div className='fw-medium'>Date Created :</div><div className='fw-medium'>{noteDate}</div></div>
        </div>
        <div className='fw-medium'>Subject :</div>
        <div className='fw-medium mb-2'>{noteDetails.ActivityName}</div>  
        <div className='fw-medium '>Body :</div>
        <div className='detail p-2' id='notesTabContent' style={{ overflowY: 'scroll', height: "50vh" }} dangerouslySetInnerHTML={{ __html: noteDetails.ActivityDescriptionHTML }}></div>
      </>
    )
  }

  const ToolTip = () => {
    const colDef = [
      {

        headerName: '',
        field: 'DocumentId',
        maxWidth: 25,
        cellRenderer: (params) => {
          const docExt = params.data.DocumentExtension;

          const singleDocIcon = `far fa-file-${(docExt === 'pdf' || docExt === '.pdf') ? 'pdf':'excel'} SBA_hand`;
          const singleDocColor = (docExt === 'pdf' || docExt === '.pdf') ? 'red' : 'green';
          console.log('document: ', params.data);
          
          return <i 
            className={singleDocIcon} 
            style={{ color: singleDocColor} }
          ></i>;
        },
      },
        {field: 'DocumentName', headerName: "Document"}
    ]
    return <div className="ag-theme-alpine" style={{ width: '450px' ,pointerEvents:'auto' ,height:'auto'}}>
        <AgGridReact
            rowData={documents}
            columnDefs={colDef}
            defaultColDef={{ flex: 1,resizable:true }}
            onRowClicked={(params)=>{pdfview(params.data?.DocumentId)}}
        ></AgGridReact>
    </div>
};

  const handleIconClick = (params) => {
    iconOnClick(params);
    setShowDocuments(true);
  };

  const handleRowClick = (params) =>{
    if(params?.data?.DocCount === 1){
      pdfview(params?.data?.DocumentId)
    }
    else if(params?.data?.DocCount > 1){
      fetchMultiDocuments(params?.data?.ActivityId)
      setShowMultiDocModal(true);
    }
    else if(params?.data?.DocCount === 0) {
      toast.error('No Documents Available')
    }
  }

  const columnDefs = [
    {

      headerName: '',
      field: 'DocumentId',
      maxWidth: 25,
      cellRenderer: (params) => {
        const docExt = (params.data.DocExt || '')?.toLowerCase();
        const docCount = params.data.DocCount;
      
        const isPDF = docExt === 'pdf' || docExt === '.pdf';
        const singleDocIcon = `far fa-file-${isPDF ? 'pdf' : 'excel'} SBA_hand`;
        const multiDocIcon = 'far fa-solid fa-file';
        const singleDocColor = isPDF ? 'red' : 'green';
      
        if (docCount === 0) {
          return null;
        } else {
          return (
            <i
              className={docCount === 1 ? singleDocIcon : multiDocIcon}
              style={{ color: `${docCount === 1 ? singleDocColor : '#ffd86c'}` }}
              onClick={() => {
                handleRowClick(params);
              }}
            ></i>
          );
        }
      },
    },
    {
      tooltipField: 'DocumentDate',
      field: "DocumentDate", headerName: "Date",
      // width: "145%",
      maxWidth: 125,
      valueFormatter: function (params) {
        return moment(params.value).format('MM/DD/YYYY');
      }
    },
    { 
      tooltipField: 'ActivityName',
      field: "ActivityName", headerName: "Document" },


  ];
  const gridOptions = {
    defaultColDef: {
       resizable: true,
       sortable: true,
        filter: true,
        flex:1
    },
   rowHeight: 30,
    
};
  return (
    <div>
          <div className="ag-theme-alpine"  style={{ width: '100%', height: '300px' }}>
       
        {assetDocuments?.length>0 ? 
        <>  <AgGridReact
          columnDefs={columnDefs}
          rowData={assetDocuments}
         gridOptions={gridOptions}
         defaultColDef={{resizable:true}}
         onRowDoubleClicked={handleIconClick}
        />
        </>: 
  <div className='d-flex w-100 my-4 h-100'>
                                <img src={noDataAvailable} alt='NO DATA AVAILABLE' className='m-auto' width={'30%'}/>
                                </div>}
        <Modal
            show={showDocuments}
            onHide={handleClose}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
        
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable w-100 " >
                <div class="modal-content p-2 overflow-auto " >
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="DocumentsModalLabel">Documents
                        </h1>
                        <button type="button" class="btn-close" onClick={handleClose}
                            aria-label="Close"></button>
                    </div>
                    <form action="#">
                        <div class="modal-body ">
                            <h6 class="fw-medium fs-6 mt-3">
                            </h6>
                           <DocumentTabPopUp/>
                        </div>
                    </form>
                </div>
            
           
        </div>
        </Modal>
        <Modal show={showMultiDocModal} onHide={() => setShowMultiDocModal(false)} size="md" centered>
    <Modal.Header closeButton>
        <Modal.Title>Available Documents</Modal.Title>
    </Modal.Header>
    <Modal.Body>
        {documents?.length > 0 ? (
            <ToolTip/>
        ) : (
            <p>No Documents Available</p>
        )}
    </Modal.Body>
</Modal>
      </div>
    </div>
  )
}

